var map = {
	"./address_image.svg": 73,
	"./animated_ashutosh.png": 74,
	"./animated_logo.svg": 75,
	"./blogs_image.svg": 76,
	"./cloud_infrastructure.svg": 77,
	"./codeInLogo.png": 78,
	"./contactMail.png": 79,
	"./coursera_logo.png": 80,
	"./cpp_logo.png": 81,
	"./data_science.svg": 82,
	"./deeplearning_ai_logo.png": 83,
	"./delhivery_logo.png": 84,
	"./developerActivity.svg": 85,
	"./dsc_logo.png": 86,
	"./education.svg": 87,
	"./experience.svg": 88,
	"./feelingProud.svg": 89,
	"./freecopy_logo.png": 90,
	"./fullstack.svg": 91,
	"./gcp_logo.png": 92,
	"./github_logo.png": 93,
	"./googleAssistant.jpg": 94,
	"./googleAssistant.svg": 95,
	"./google_logo.png": 96,
	"./home-bg.png": 97,
	"./ibm_logo.png": 98,
	"./iiitk_logo.png": 99,
	"./intel_logo.jpg": 100,
	"./iu_logo.png": 101,
	"./jsFramework.svg": 102,
	"./legato_logo.png": 103,
	"./lofi_mark.png": 104,
	"./manOnTable.svg": 105,
	"./microsoft_logo.png": 106,
	"./mozilla_logo.png": 107,
	"./muffito_logo.png": 108,
	"./nextuLogo.jpg": 109,
	"./nptel_logo.png": 110,
	"./portfolio.gif": 111,
	"./programmer.svg": 112,
	"./projects_image.svg": 113,
	"./pwa.png": 114,
	"./saayaHealthLogo.png": 115,
	"./stanford_logo.png": 116,
	"./swiss_knife.png": 117,
	"./talksCardBack.svg": 118,
	"./talksCardBackAlt.svg": 119,
	"./tiktok_logo.png": 120,
	"./ui_ux_design.svg": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;